// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Container from '../../common/container/Container'
import Loader from '../../common/loader/Loader'
import Header from '../header/Header'
import { i18n } from '../index'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import css from './BudgetPlanning.css'
import BudgetPlanningPage from './BudgetPlanningPage'
import { fetchProfitCenters } from './budgetPlanningQueries'

type Props = {
  activeStation: Station
}

@withActiveStation
class BudgetPlanning extends React.Component<Props> {
  // remove profit with type 'Other', add an option to select 'all' from dropdown
  processDropdownContent = (station: Station): Array<any> => {
    const profitCenters = get(station, 'profitCenters', []).filter((profitCenter) => profitCenter.type !== 'Other')
    return [
      {
        ...station,
        name: i18n.t('budgetPlanning.all'),
        type: 'Station',
        profitCenters,
      },
      ...profitCenters,
    ]
  }

  render() {
    const {
      activeStation: { id: stationId },
    } = this.props

    return (
      <div className={css.component}>
        <Header title={i18n.t('budgetPlanning.header')} />
        <Container>
          <Typography variant='h6'>{i18n.t('budgetPlanning.header')}</Typography>
          <Query query={fetchProfitCenters} variables={{ stationId }}>
            {({ loading, error, data }) => (
              <Loader {...{ loading, error }}>
                <BudgetPlanningPage
                  stationId={stationId}
                  options={this.processDropdownContent(get(data, 'station', {}))}
                />
              </Loader>
            )}
          </Query>
        </Container>
      </div>
    )
  }
}

export default BudgetPlanning
